import React, { FC, ReactElement, useEffect, forwardRef } from 'react';
import { makeStyles, createStyles, useTheme, Theme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';

import { useHistory, useRouteMatch } from 'react-router-dom';
import { ROOT } from '@public/constants/routes';

const DOCUMENT = 'private-policy';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      minWidth: theme.spacing(30),
    },
    markdownContainer: {
      '& a': {
        color: theme.palette.primary.main,
      },
    },
    dialogContent: {
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(4),
      },
      overflow: 'hidden',
    },
    dialogTitle: {
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(4),
      },
    },
    dialogActions: {
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(4),
      },
    },
    styleDialog: {
      height: '100%',
      width: '100%',
    },
  }),
);

const DialogTransition = forwardRef((
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) => <Slide ref={ref} direction="up" {...props} />);

type Props = {
  title: string;
  uri: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  onPage?: boolean;
  buttonTitle?: string;
  addingActionOnButton?: () => void;
  home?: boolean;
};

const Documents: FC<Props> = ({
  title,
  uri,
  open,
  setOpen,
  onPage = false,
  buttonTitle = 'Закрыть',
  addingActionOnButton,
  home = false,
}) => {
  const classes = useStyles();

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const history = useHistory();

  const handleClose = (): void => {
    setOpen(false);
    home && history.push(`${ROOT}`);
  };

  useEffect(() => {
    if (onPage) {
      setOpen(true);
    }
  }, []);

  const dialogElementContent: ReactElement = (
    <>
      <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <object style={{ width: '100%', height: '100%' }}>
          <iframe src={uri} style={{ width: '100%', height: '100%' }} />
        </object>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        {buttonTitle === 'Принять' && (
          <Button
            className={classes.button}
            id={`${DOCUMENT}__back-button`}
            onClick={() => {
              handleClose();
            }}
          >
            Назад
          </Button>
        )}
        <Button
          className={classes.button}
          id={`${DOCUMENT}__close-button`}
          color="primary"
          onClick={() => {
            if (addingActionOnButton) {
              addingActionOnButton();
              setTimeout(() => {
                handleClose();
              }, 100);
            } else {
              handleClose();
            }
          }}
        >
          {buttonTitle}
        </Button>
      </DialogActions>
    </>
  );

  return (
    <>
      <Dialog
        TransitionComponent={isXs ? DialogTransition : undefined}
        open={open}
        maxWidth="xl"
        fullScreen={isXs}
        classes={{ paper: classes.styleDialog }}
      >
        {dialogElementContent}
      </Dialog>
    </>
  );
};

export default Documents;
